import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from '../store/store';

import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);
Vue.config.productionTip = false
global.Vue = Vue

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
